export default __webpack_public_path__ + "static/media/pushup.80ee10e3.jpg";